<template lang="html">
  <b-row class="case-block mb-2 pt-2">
    <b-col md="5" lg="3" xl="2" class="case-info">
      <p>
        <span class="reportLabel">Incident Date</span>
        {{ oigCase.eventDate }}
      </p>
      <div v-if="oigCase.allegations">
        <span class="reportLabel">Allegations</span>
        <ul class="pl-0">
          <li v-for="allegation in oigCase.allegations">{{ allegation }}</li>
        </ul>
      </div>
      <p>
        <span class="reportLabel">Incident Type</span>
        {{ oigCase.caseType }}
      </p>
      <div class="ratings">
        <div class="row" v-if="oigCase.indicators.length">
          <span class="reportLabel">Indicator Ratings<span v-if="oigCase.status != 'Published'">*</span></span>
          <span class="figure-caption mt-2" v-html="'Indicators 1-' + Object.keys(oigCase.indicators).length"></span>
        </div>
        <div class="row pt-1" v-if="oigCase.indicators.length">
          <div class="col" v-for="i in [1, 2, 3]">
            <span class="dot"
              v-bind:class="(typeof oigCase.indicators[i] !== 'undefined' ? oigCase.indicators[i].rating : '')"></span>
          </div>
        </div>
        <div class="row" v-else>
          <span class="reportLabel">Overall Rating<span v-if="oigCase.status != 'Published'">*</span></span>
        </div>
        <div v-if="oigCase.assessment.overallRating" class="row pt-2">
          <div class="col caseRating" v-bind:class="oigCase.assessment.overallRating.toLowerCase()">
            {{ oigCase.assessment.overallRating }}</div>
        </div>
        <b-row>
          <b-col cols="12" class="mt-2 font-italic text-center">
            <span class="draftText" v-if="oigCase.status !== 'Published' || oigCase.status !== 'Final Public Report'">
              <p>*Ratings subject to change</p>
            </span>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col class="case-text">
      <span class="reportLabel">OIG Incident Number</span>
      <span>
        <p class="font-weight-bold">{{ oigCase.number }}</p>
      </span>
      <span class="reportLabel">Incident Summary</span>
      <span v-html="oigCase.summary"></span>
      <span v-if="oigCase.disposition.length" class="reportLabel">Disposition</span>
      <span v-if="oigCase.disposition.length" v-html="oigCase.disposition"></span>
      <span class="reportLabel">Incident Rating</span>
      <span v-html="oigCase.assessment.assessment"></span>
      <hr />
      <Indicator :indicator="indicator" :oigCase="oigCase" v-for="indicator in oigCase.indicators"
        v-bind:key="indicator.number" />
    </b-col>
  </b-row>
</template>

<script>
import Indicator from '../DMU/CaseSummaries/Indicator.vue'
export default {
  props: ['oigCase'],
  components: {
    Indicator
  },
  data() {
    return {
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },
}
</script>

<style lang="css" scoped>
.draftText {
  font-size: 0.7rem;
}

.case-block hr {
  border-top: 0.18rem double rgba(0, 0, 0, .1);
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
}

.ratings .row .col {
  width: 30%;
  text-align: center;
}

.custom-switch .toggle-questions {
  width: 100%;
  font-size: 0.6rem;
}

.caseRating {
  text-align: center;
  font-weight: bold;
  color: white;
  padding: 2.5% 0 1%;
}

.case-block {
  word-wrap: break-word;
  font-size: 0.7rem;
  background-color: #F8F9FA;
  background-image: url('../../assets/dot.png');
  background-repeat: repeat-x;
  font-family: "Nunito", Arial, sans-serif;
  page-break-after: always;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.reportLabel {
  display: block;
  font-family: "Nunito", Arial, sans-serif;
  color: #223d6b;
  font-weight: bold;
  font-size: 0.8rem;
}

.case-text .reportLabel {
  color: #b79d61;
}

.dot {
  height: 0.9rem;
  width: 0.9rem;
  background-color: lightgrey;
  border-radius: 50%;
  display: inline-block;
}

.superior,
.sufficient {
  background-color: #395a94;
}

.satisfactory {
  background-color: #abc094;
}

.poor,
.insufficient {
  background-color: #e79e94;
  color: #a94442
}

@media print {
  .btn {
    display: none;
  }
}

@media (min-width: 1920px) {}</style>
